import React from "react";

// "Selected Categories" (même idée que la section Categories de Seller Edit
// Product) : toutes les catégories liées au produit, chacune retirable
// individuellement. Retirer une catégorie ne supprime JAMAIS le produit : seule la
// relation Produit ↔ Catégorie disparaît. L'ajout ("+ Link Category") ouvre le
// même sélecteur de catégories que le reste du wizard (fourni par le parent).
const ProviderCategoriesManager = ({ linked, onRemove, onLink, linking, t }) => (
  <div className="provider-categories mb-3">
    <h3 className="h6">{t("t161")}</h3>
    {linked.length === 0 ? (
      <p className="text-muted">{t("t164")}</p>
    ) : (
      <ul className="provider-categories__list">
        {linked.map((c) => (
          <li key={c._id} className="provider-categories__item">
            <span>{Array.isArray(c.name) && c.name.length ? c.name.join(" › ") : c._id}</span>
            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => onRemove(c._id)} aria-label={`${t("t163")}: ${Array.isArray(c.name) ? c.name[0] : c._id}`}>
              {t("t163")}
            </button>
          </li>
        ))}
      </ul>
    )}
    <button type="button" className="btn btn-outline-primary btn-sm" onClick={onLink} aria-expanded={Boolean(linking)}>
      {t("t162")}
    </button>
  </div>
);

export default ProviderCategoriesManager;
